import downloadFile from '@framework/api/downloadFile';
import isServer from '@framework/router/Next/isServer';

interface IHistory {
  replace: (location: { pathname: string, search: string }) => void,
}

export function initAutoDownload(history?: IHistory): void {
  if (isServer()) {
    return;
  }

  const searchParams = new URLSearchParams(window.location.search);
  const autoDownload = searchParams.get('auto_download');
  if (autoDownload) {
    downloadFile(autoDownload);
    searchParams.delete('auto_download');

    const search = searchParams.toString();
    const url = search ? `${ window.location.pathname }?${ search }` : window.location.pathname;

    if (history) {
      history.replace({ pathname: window.location.pathname, search });
    } else {
      window.history.replaceState(null, '', url);
    }
  }
}
